<template>
  <div class="container-fluid">
    <Header/>

    <div class="container">
      <div class="row page-name">
        <div class="col">
          <h2>Create a quiz</h2>
        </div>
      </div>

      <div class="row subject-info pt-3">
        <div class="col-4">
          <h4 class="inputTitle mb-1">Subject</h4>
          <Select
            selectName="Subject"
            v-model="questionData.choosenSubject"
            :options="subjectOptions"
          ></Select>
        </div>

        <div class="col-4">
          <h4 class="inputTitle mb-1">Date</h4>
          <div class="d-flex">
            <input type="number" class="numberInput mr-2" placeholder="Day">
            <input type="number" class="numberInput" placeholder="Month">
          </div>
        </div>

        <div class="col-4">
          <h4 class="inputTitle mb-1">Time Limit</h4>
          <input
            type="number"
            v-model="questionData.timeLimit"
            class="numberInput"
            placeholder="Minutes"
          >
        </div>
      </div>

      <div class="row subject-info pt-3">
        <div class="col-4">
          <h4 class="inputTitle mb-1">Type</h4>
          <Select selectName="Question Type" v-model="choosenType" :options="questionOptions"></Select>
        </div>

        <div class="col-4">
          <h4 class="inputTitle mb-1">Points</h4>
          <div class="d-flex">
            <input type="number" class="numberInput" placeholder="Point">
          </div>
        </div>
      </div>

      <div class="row spinner justify-content-center align-items-center" v-if="spinner">
        <img src="../assets/images/spinner.svg" alt>
      </div>

      <div
        class="row flex-column question-constructor px-5 mt-5"
        v-for="(question, index) in questions"
        :key="index"
      >
        <div class="col qs-title mb-3">
          <Question v-model="question.questionText" :questionNumber="index + 1"></Question>
        </div>

        <div class="col qs-answers">
          <Answer
            :attach="true"
            @checked="checkAnswer(index, $event)"
            @mounted="mountAnswers(index, $event)"
            :type="question.questionType"
            class="mb-2"
          ></Answer>
        </div>
      </div>

      <div class="row controllers flex-row-reverse px-5 mt-2">
        <div class="next-btn order-3">
          <button @click="addQuestion()">Next Question</button>
        </div>

        <div class="print-btn order-2">
          <button>Print</button>
        </div>

        <div class="done-btn order-1">
          <button @click="submitQuestions()">Done</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Select from "@/components/Select.vue";
import Answer from "@/components/Answer.vue";
import Question from "@/components/Question.vue";
import { setTimeout } from "timers";

export default {
  name: "AddQuiz",
  data() {
    return {
      subjectOptions: [],
      choosenType: null,
      spinner: false,
      questions: [],
      questionData: {
        choosenSubject: null,
        timeLimit: null
      },

      questionOptions: [
        {
          text: "Write answer",
          value: "writeAnswer"
        },
        {
          text: "True/False",
          value: "trueFalse"
        },
        {
          text: "Multiple Choice",
          value: "multipleChoice"
        }
      ]
    };
  },
  methods: {
    checkAnswer(index, value) {
      this.questionOptions[index] = value;
    },

    mountAnswers(index, value) {
      this.questions[index].answers = value;
    },

    addQuestion() {
      this.questions.push({
        questionType: this.choosenType,
        questionText: "",
        answers: []
      });
    },

    submitQuestions() {
      const readyQuestions = this.questions.map(_question => {
        const answer = _question.answers.find(answer => answer.checked).text;
        const question = _question.questionText;
        const type = _question.questionType;

        let variants;

        if (_question.questionType === "writeAnswer") {
          variants = [];
        } else if (_question.questionType === "trueFalse") {
          variants = ["True", "False"];
        } else if (_question.questionType === "multipleChoice") {
          variants = _question.answers.map(answer => answer.text);
        }

        return {
          question,
          type,
          answer,
          variants
        };
      });

      const reqData = {
        subject: this.questionData.choosenSubject,
        timeLimit: this.questionData.timeLimit,
        questions: readyQuestions
      };

      const tmpQuestions = this.questions;
      this.questions = [];
      this.spinner = true;

      axios
        .post(`${apiUrl}/quiz/create`, reqData)
        .then(res => {
          console.log(res.data);

          if (res.data.status) {
            this.spinner = false;
          } else {
            this.questions = tmpQuestions;
            this.spinner = false;
          }
        })
        .catch(err => console.log(err));
    }
  },
  created() {
    const teacherData = JSON.parse(sessionStorage.getItem("teacherData"));

    this.subjectOptions = teacherData.subjects.map(({ name }) => ({
      text: name,
      value: name
    }));
  },
  components: {
    Header,
    Select,
    Answer,
    Question
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables";

.container-fluid {
  padding: 0;
}

.container {
  padding: 1.8rem 0;
}

.page-name h2 {
  color: $black;
}

.subject-info {
  .inputTitle {
    color: $black;
    font-weight: 500;
  }

  .numberInput {
    padding: 0.4rem 0.9rem;
    width: 100%;
    color: $placeholderColor;
    background-color: $grey;
    border-radius: $borderRadius;
    border: none;
    outline: none;
  }

  .numberInput::placeholder {
    color: $placeholderColor;
  }
}

.controllers {
  [class*="-btn"] button {
    outline: none;
    border: none;
    border-radius: $borderRadius;
    padding: 6px 12px;
    transition: all 0.3s ease;
    color: #fff;
    margin: 0 6px;
  }

  .next-btn {
    button {
      background-color: $green;
    }
  }

  .print-btn {
    button {
      background-color: $violet;
    }
  }

  .done-btn {
    button {
      background-color: $blue;
    }
  }
}
</style>

